
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const moduleProgress = {
    state: {
      prgActive: false,
      statusValue: 0,
      prgText: '',
      timeOut: 0
    },
    mutations: {
      showProgressBar (state, Status) {
        state.statusValue = 0
        state.prgActive = true
        state.prgText = Status.text
        //if (Status.timeOut) state.timeOut = Status.timeOut; else state.timeOut = 0
        
      },
      updateProgress(state,StatusValue){
        state.statusValue = Math.round(StatusValue*100)
      },
      closeProgressBar (state) {
        state.prgActive = false
      }
    },
    getters: {
      getStatusValue (state) {
        return state.statusValue
      },
      getPrgText (state) {
        return state.prgText
      },
      getPrgActive (state) {
        return state.prgActive
      },
      getPrgTimeOut (state) {
        return state.timeOut
      }
    }
  }